import { purgeLegacyJwtFromStorage } from './authSession';

const AUTH_TOKEN_HEADER = 'x-auth-token';

export function extractAuthToken(response) {
  if (!response) return null;
  
  const url = response.config?.url || '';
  if (
    url.includes('/invite-admin') ||
    url.includes('/invite-doctor') ||
    url.includes('/register-doctor')
  ) {
    return response.headers?.[AUTH_TOKEN_HEADER] || null;
  }

  return response.headers?.[AUTH_TOKEN_HEADER] || response.data?.token || null;
}

/**
 * BULGU-016: JWT artık localStorage'a yazılmaz; httpOnly cerez + (varsa) X-Auth-Token
 * yanıt başlığı sunucu tarafında set edilir. Eski anahtarlar temizlenir.
 */
export function persistAuthToken(response, storageKey) {
  const token = extractAuthToken(response);
  if (token && storageKey) {
    purgeLegacyJwtFromStorage();
  }
  return token;
}
